import { Alert, Button, Stack, Text } from "@mantine/core";
import { Link } from "@remix-run/react";
import { IconBrandWhatsapp, IconMail } from "@tabler/icons-react";

import { useTranslation } from "~/hooks/use-typed-translation";

export function BookingAvailabilityHelp({ doctorName, serviceName, profilePath, directoryPath, specialty, mode, packageUnavailable = false }: {
  doctorName: string;
  serviceName?: string;
  profilePath: string;
  directoryPath?: string;
  specialty?: string;
  mode?: string;
  packageUnavailable?: boolean;
}) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === "fr" ? "fr" : "en";
  const query = new URLSearchParams();
  if (specialty) query.set("q", specialty);
  if (mode === "teleconsultation" || mode === "homecare") query.set("modeOfService", mode);
  const body = t("availability-help-message", {
    doctor: doctorName,
    service: serviceName || t("service-type"),
    url: `https://appointment.laruche.health${profilePath}`,
  });
  return (
    <Alert variant="light" color="gray" title={t(packageUnavailable ? "availability-package-title" : "availability-empty-title")}>
      <Stack gap="sm">
        <Text fz={14}>{t("availability-help-description", { doctor: doctorName })}</Text>
        <Button component="a" target="_blank" rel="noopener noreferrer"
          leftSection={<IconBrandWhatsapp size={18} aria-hidden="true" />}
          href={`https://wa.me/2250504783682?text=${encodeURIComponent(body)}`}>
          {t("availability-whatsapp-help")}
        </Button>
        <Button component="a" variant="subtle"
          leftSection={<IconMail size={18} aria-hidden="true" />}
          href={`mailto:rendezvous@laruche.health?subject=${encodeURIComponent(t("availability-email-subject", { doctor: doctorName }))}&body=${encodeURIComponent(body)}`}>
          {t("availability-email-help")}
        </Button>
        <Button component="a" variant="subtle" href="tel:+2250504783682">{t("availability-call-help")}</Button>
        <Button component={Link} variant="outline" to={`${directoryPath ?? `/${locale}`}?${query.toString()}`}>
          {t("availability-browse-doctors")}
        </Button>
      </Stack>
    </Alert>
  );
}
